<!--
  +---------------------------------------------------------------------------------------
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     修改密码
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="f-password-modify"
    width="900px"
    title="修改密码"
    :visible.sync="dialogShow"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    @open="onDialogOpen">
    <el-steps
      :active="active"
      process-status="success"
      finish-status="success"
      simple>
      <el-step title="验证身份" />
      <el-step title="设置密码" />
      <el-step title="完成" />
    </el-steps>
    <div class="text-center" style="width: 400px; margin: 80px auto">
      <el-form
        v-show="active === 0"
        ref="postForm0"
        :model="formData"
        :rules="rules0"
        status-icon
        label-position="left"
        label-width="100px">
        <el-form-item label="原密码" prop="oldpwd">
          <el-input v-model="formData.oldpwd" type="password" clearable />
        </el-form-item>
      </el-form>
      <el-form
        v-show="active === 1"
        ref="postForm1"
        :model="formData"
        :rules="rules1"
        status-icon
        label-position="left"
        label-width="100px">
        <el-form-item label="新密码" prop="newpwd">
          <el-input v-model="formData.newpwd" clearable />
        </el-form-item>
      </el-form>
      <div v-show="active === 2">
        <div class="font-4x text-success"><i class="el-icon-success" /></div>
        <p><span class="font-lg">密码设置成功，请您重新登录！</span></p>
      </div>
    </div>
    <div slot="footer" class="text-center mb">
      <el-button v-show="active === 0" class="extend" plain @click="dialogShow = false">取消</el-button>
      <el-button v-show="active === 0" class="extend" type="primary" :disabled="!pwdValid" @click="onPostForm0Submit">下一步</el-button>
      <el-button v-show="active === 1" class="extend" type="primary" @click="onPostForm1Submit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { postUserInfoApi } from '@/api/fam/famUserApi'
import { validateRamUsername } from '@/utils/validate'

export default {
  name: 'FPasswordModify',

  components: {
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    var validOldPwd = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('原密码不能为空！'))
      }
      postUserInfoApi({ oldpwd: value }).then((res) => {
        if (!res.errno) {
          this.pwdValid = true
          return callback()
        }
        return callback(new Error('密码不正确！'))
      })
    }
    var validNewPwd = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('新密码不能为空！'))
      }
      if (value === this.formData.oldpwd) {
        return callback(new Error('新密码不能与旧密码相同！'))
      }
      if (validateRamUsername(value)) {
        callback()
      } else {
        return callback(new Error('密码格式不正确！'))
      }
    }

    return {
      active: 0,
      pwdValid: false,
      formData: {
        oldpwd: '',
        newpwd: ''
      },
      rules0: {
        oldpwd: [
          { validator: validOldPwd, trigger: 'blur' }
        ]
      },
      rules1: {
        newpwd: [
          { validator: validNewPwd, trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  watch: {
    active(val) {
      if (val === 2) {
        setTimeout(() => {
          this.$store.dispatch('logOut').then(() => {
            location.reload()
          })
        }, 3000)
      }
    }
  },

  created() {
  },

  methods: {
    resetData() {
      this.active = 0
      this.pwdValid = false
      this.formData.oldpwd = ''
      this.formData.newpwd = ''
    },

    onDialogOpen() {
      this.resetData()
      this.$nextTick(() => {
        this.$refs['postForm0'].clearValidate()
        this.$refs['postForm1'].clearValidate()
      })
    },

    onPostForm0Submit() {
      this.active = 1
    },

    onPostForm1Submit() {
      this.$refs['postForm1'].validate((valid) => {
        if (valid) {
          postUserInfoApi(this.formData).then((res) => {
            if (!res.errno) {
              this.active = 2
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.f-password-modify {
}
</style>
